import { isLockedWidget } from '@/components/forms/utils/links';

import { RadioGroup, RadioGroupItem } from '@/shadcn/radio-group';
import { Label } from '@/shadcn/label';
import { type WidgetWriterProps } from '../widget.type';
import { TestId } from '@/types/testId';

type Props = {
  options: {
    enumOptions: [{ label: string; value: string }];
    enumDisabled: string[];
  };
} & WidgetWriterProps;

export const Radio = (props: Props) => {
  const {
    id,
    name,
    options,
    value = '',
    disabled,
    readonly,
    onChange,
    formContext,
    invalid
  } = props;

  const { enumOptions, enumDisabled } = options;

  // check if the widget is locked because of forms links
  const isLocked = isLockedWidget(id, formContext.links);

  const disabledGroup = disabled || readonly || isLocked;
  if (enumOptions.length < 2) {
    console.error(
      'Minimum 2 options should be added to radio buttons within the JSONSchema'
    );
  }
  return (
    <RadioGroup
      onValueChange={value => onChange(value)}
      value={value}
      disabled={disabledGroup}
      className="gap-1"
      data-cy={`radio-${name}`}
      data-testid={TestId.FormWriter.Radio.RadioGroup}
      id={id}
    >
      {enumOptions.map(option => {
        const disabledOption =
          enumDisabled && enumDisabled.indexOf(option.value) !== -1;
        const uniqueKey = `${name}-${option.value}`;

        return (
          <div
            key={uniqueKey}
            className="text-foreground/60 hover:text-foreground/90 flex h-7 cursor-pointer flex-row items-center gap-2"
          >
            <RadioGroupItem
              id={uniqueKey}
              value={option.value}
              checked={option.value === value}
              data-cy={`radio-${uniqueKey}`}
              data-testid={TestId.FormWriter.Radio.RadioItem}
              disabled={disabledGroup || disabledOption}
              aria-invalid={invalid}
            />
            <Label
              htmlFor={uniqueKey}
              className="flex h-full grow cursor-pointer items-center truncate pt-0.5 font-medium"
            >
              {option.label}
            </Label>
          </div>
        );
      })}
    </RadioGroup>
  );
};
